export default __webpack_public_path__ + "static/media/Zoning.cc8207b4.svg";